import { FreeTextScreenerDef } from "./assessment-types";
import { ANNUAL_WELLNESS_SCREENER } from "./screeners/annual-wellness-screener-constant";
import { DIABETIC_SCREENER } from "./screeners/diabetic-screener-constant";
import { OBESITY_SCREENER } from "./screeners/obesity-screener-constant";
import { TOBACCO_SCREENER } from "./screeners/tobacco-screener-constant";

// Screeners answered with ticked options and typed text (ECRH-6595). Question
// text comes from the screener API; these definitions say how each is answered.
export const FREE_TEXT_SCREENERS: Record<string, FreeTextScreenerDef> = {
  OBESITY_SCREENING: OBESITY_SCREENER,
  TOBACCO_SCREENING: TOBACCO_SCREENER,
  DIABETES_ASSESSMENT: DIABETIC_SCREENER,
  ANNUAL_WELLNESS: ANNUAL_WELLNESS_SCREENER,
};
